import { FormikHelpers } from 'formik';
import React, { FC } from 'react';
import { FormLabel } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import CheckBox from '../../../../library/inputs/checkbox/CheckboxInput';

interface Props {
  id: string;
  enabled: boolean;
  value: boolean;
  setFieldValue: FormikHelpers<string>['setFieldValue'];
  setFieldTouched: FormikHelpers<string>['setFieldTouched'];
  readOnlyMode?: boolean;
}

const AcknowledgmentField: FC<Props> = ({
  id,
  enabled,
  value,
  setFieldValue,
  setFieldTouched,
  readOnlyMode,
}: Props) => {
  return (
    <CheckBox
      id={id}
      label={
        <FormLabel>
          <FormattedMessage id="public.controls.acknowledgment.text"></FormattedMessage>
        </FormLabel>
      }
      value={value}
      enabled={enabled}
      onChange={async (e) => {
        await setFieldValue(id, e.target.checked, true);
        await setFieldTouched(id, true, true);
      }}
      readOnlyMode={readOnlyMode}
    />
  );
};

export default AcknowledgmentField;
